"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { ChangeDetectionStrategy, Component, Inject, Input, Renderer2, ViewChild, } from '@angular/core';
import { UI_CONFIG } from '../ui.config';
import { IconService } from './icon.service';
var IconComponent = (function () {
    function IconComponent(renderer, iconService, uiConfig) {
        this.renderer = renderer;
        this.iconService = iconService;
        this.uiConfig = uiConfig;
        this.color = 'inherit';
        this.size = 'mid';
        this.backdrop = undefined;
    }
    Object.defineProperty(IconComponent.prototype, "legacy", {
        set: function (value) {
            this.attrLegacy = value ? true : undefined;
        },
        enumerable: true,
        configurable: true
    });
    IconComponent.prototype.setElement = function (svg) {
        var _this = this;
        var layoutElement = this.container.nativeElement;
        // Detach all views of the child nodes of the root element.
        // NOTE: This wouldn't work in IE 11 because there's a bug there that
        // causes SVG to not be included in the list.
        // We've polyfilled it though.
        // Ref: https://github.com/angular/angular/issues/6327
        Array.from(layoutElement.childNodes).forEach(function (node) {
            _this.renderer.removeChild(layoutElement, node);
        });
        // Put the new icon SVG in.
        this.renderer.appendChild(layoutElement, svg);
    };
    IconComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        var changedInputs = Object.keys(changes);
        if (changedInputs.includes('name')) {
            // Check if the new value is not an empty string or undefined.
            if (changes.name.currentValue) {
                this.iconSubscription = this.iconService
                    .getIcon(this.uiConfig.assetsBaseUrl + "/icons/" + changes.name
                    .currentValue + ".svg", this.renderer)
                    .first()
                    .subscribe(function (svg) {
                    _this.setElement(svg);
                });
            }
        }
        if (changedInputs.includes('label')) {
            this.attrAriaHidden = changes.name.currentValue ? undefined : true;
        }
    };
    IconComponent.prototype.ngOnDestroy = function () {
        if (this.iconSubscription !== undefined) {
            this.iconSubscription.unsubscribe();
        }
    };
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], IconComponent.prototype, "name", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], IconComponent.prototype, "label", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], IconComponent.prototype, "color", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], IconComponent.prototype, "hoverColor", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], IconComponent.prototype, "size", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], IconComponent.prototype, "backdrop", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], IconComponent.prototype, "legacy", null);
    __decorate([
        ViewChild('container'),
        __metadata("design:type", Object)
    ], IconComponent.prototype, "container", void 0);
    IconComponent = __decorate([
        Component({
            selector: 'fl-icon',
            template: "\n    <div class=\"IconBackdrop\"\n      [attr.data-color]=\"backdrop\"\n      [attr.data-size]=\"size\"\n    >\n      <div #container\n        class=\"IconContainer\"\n        [attr.data-color]=\"color\"\n        [attr.data-hover-color]=\"hoverColor\"\n        [attr.data-size]=\"size\"\n        [attr.data-legacy]=\"attrLegacy\"\n        [attr.aria-label]=\"label\"\n        [attr.title]=\"label\"\n        [attr.aria-hidden]=\"!attrAriaHidden\"\n      ></div>\n    </div>\n  ",
            styleUrls: ['./icon.component.scss'],
            changeDetection: ChangeDetectionStrategy.OnPush,
        }),
        __param(2, Inject(UI_CONFIG)),
        __metadata("design:paramtypes", [Renderer2,
            IconService, Object])
    ], IconComponent);
    return IconComponent;
}());
export { IconComponent };



// WEBPACK FOOTER //
// icon.component.js